import { FC } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export const ZKComp: FC = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(locale === 'za' ? 'delta2max.detail' : 'delta2max.teaser');
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const IS_ROW = ['au', 'br', 'mx', 'za', 'ph', 'sa'].includes(locale);
    const items = [
        { title: t('sec20_d2x'), key: 1 },
        { title: t('sec20_ac'), key: 2 },
        { title: t('sec20_card'), key: 5 },
    ];

    return (
        <div id="the-box" className={`${css.ZKComp} GtmModuleData-section`} data-section-id={css.ZKComp} data-section-title={t('sec20_title')}>
            <div className="box-title">{t('sec20_title')}</div>
            {IS_EU || IS_ROW ? (
                <div className="box-eu">
                    {items.map((item, index) => (
                        <div className={`item item-${item.key}`} key={index} style={{ gridArea: `box-${item.key}` }}>
                            <div className="img-box">
                                <NextImage
                                    webpSrc={require(`@publicLocal/delta2max/teaser/pc/eu/19-${item.key}${item.key === 5 ? '_eu' : ''}.webp`)}
                                    src={require(`@publicLocal/delta2max/teaser/pc/eu/19-${item.key}${item.key === 5 ? '_eu' : ''}.png`)}
                                    alt={item.title}
                                    aria-label={item.title}
                                />
                            </div>
                            <div className="item-title">{item.title}</div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="grid-box">
                    <div className="box-1 item-box">
                        <div className="img-box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/19-1.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/19-1.png')}
                                alt={t('sec20_d2x')}
                                aria-label={t('sec20_d2x')}
                            />
                        </div>
                        <div className="item-title">{t('sec20_d2x')}</div>
                    </div>
                    <div className="box-r-1 item-box">
                        <div className="img-box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/19-2.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/19-2.png')}
                                alt={t('sec20_ac')}
                                aria-label={t('sec20_ac')}
                            />
                        </div>
                        <div className="item-title">{t('sec20_ac')}</div>
                    </div>
                    {locale !== 'au' && (
                        <>
                            <div className="box-r-2 item-box">
                                <div className="img-box">
                                    <NextImage
                                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/19-3.webp')}
                                        src={require('@publicLocal/delta2max/teaser/pc/eu/19-3.png')}
                                        alt={t('sec20_car')}
                                        aria-label={t('sec20_car')}
                                    />
                                </div>
                                <div className="item-title">{t('sec20_car')}</div>
                            </div>
                            <div className="box-r-3 item-box">
                                <div className="img-box">
                                    <NextImage
                                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/19-4.webp')}
                                        src={require('@publicLocal/delta2max/teaser/pc/eu/19-4.png')}
                                        alt={t('sec20_dc')}
                                        aria-label={t('sec20_dc')}
                                    />
                                </div>
                                <div className="item-title">{t('sec20_dc')}</div>
                            </div>
                        </>
                    )}
                    <div className="box-r-4 item-box">
                        <div className="img-box">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/19-5_eu.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/19-5_eu.png')}
                                alt={t('sec20_card')}
                                aria-label={t('sec20_card')}
                            />
                        </div>
                        <div className="item-title">{t('sec20_card')}</div>
                    </div>
                </div>
            )}
        </div>
    );
};
